import React, { useRef, useState } from 'react';
import _isEmpty from 'lodash-es/isEmpty';
import EditableTextComponent from '@teetsh/app/src/components/Form/EditableText';
import clsx from 'clsx';
import tw from 'twin.macro';

interface Props {
  placeholder: any;
  value?: string;
  className?: string;
  onChange: (v: string) => void;
}

export const emptyButtonStyle = tw`inline-block border border-dashed border-neutral-moderate rounded-lg text-neutral-quiet bg-neutral-quiet text-sm px-2 py-1 hover:text-neutral-intense cursor-pointer`;
export function EmptyButton(props: Props) {
  const { className, value, placeholder } = props;
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const inputRef = useRef();
  if (_isEmpty(value) && !isEditing) {
    return (
      <div
        role="presentation"
        onClick={() => {
          setIsEditing(true);
          setTimeout(() => {
            if (inputRef.current) {
              (inputRef.current as any).focus();
            }
          }, 10);
        }}
        css={emptyButtonStyle}
      >
        {placeholder}
      </div>
    );
  }
  return (
    <EditableTextComponent
      inputRef={inputRef}
      className={clsx(className)}
      value={value || ''}
      onBlur={() => {
        setIsEditing(false);
      }}
      onConfirm={(v: string) => {
        props.onChange(v);
      }}
    />
  );
}
